import { useMemo, useRef } from 'react';
import difference from 'lodash/difference';
import intersection from 'lodash/intersection';
import type { MetadataPayload } from '../../../../../../labelling-v2/studio-store/types';
type AnnotationObjectsResultT = {
  annotationObjectIds: string[];
};
export function useAnnotationObjects(annotationMetadata: Map<string, MetadataPayload>): AnnotationObjectsResultT {
  const existingIdsRef = useRef<string[]>([]);
  const resultRef = useRef<AnnotationObjectsResultT>({
    annotationObjectIds: []
  });
  return useMemo(() => {
    const currentIds = new Set<string>(annotationMetadata.keys());
    const currentIdsArray = Array.from(currentIds);
    // eslint-disable-next-line react-hooks/refs
    const newIds = difference(currentIdsArray, existingIdsRef.current);
    // eslint-disable-next-line react-hooks/refs
    const removedIds = difference(existingIdsRef.current, currentIdsArray);
    // eslint-disable-next-line react-hooks/refs
    const keptIds = intersection(existingIdsRef.current, currentIdsArray);
    if (newIds.length === 0 && removedIds.length === 0) {
      // eslint-disable-next-line react-hooks/refs
      return resultRef.current;
    }
    const orderedAnnotationObjectIds = [...keptIds, ...newIds];
    // eslint-disable-next-line react-hooks/refs
    existingIdsRef.current = orderedAnnotationObjectIds;
    // eslint-disable-next-line react-hooks/refs
    resultRef.current = {
      annotationObjectIds: orderedAnnotationObjectIds
    };
    return resultRef.current;
  }, [annotationMetadata]);
}